/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { de, enUS, es, fr, it, ja, nl, zhCN } from 'date-fns/locale';

export type Locale =
    | { code: 'nl'; name: 'Dutch' }
    | { code: 'de'; name: 'Deutsch' }
    | { code: 'en'; name: 'English' }
    | { code: 'es'; name: 'Español' }
    | { code: 'fr'; name: 'Français' }
    | { code: 'it'; name: 'Italiano' }
    | { code: 'ja'; name: '日本語' }
    | { code: 'zh-Hans'; name: '中文' };

/**
 * The supported locales in the system.
 */
export const supportedLocales: Locale[] = [
    { code: 'nl', name: 'Dutch' },
    { code: 'de', name: 'Deutsch' },
    { code: 'en', name: 'English' },
    { code: 'es', name: 'Español' },
    { code: 'fr', name: 'Français' },
    { code: 'it', name: 'Italiano' },
    { code: 'ja', name: '日本語' },
    { code: 'zh-Hans', name: '中文' }
];

export const LuisDateFormats = { Date: 'MMM d, yyyy', Time: 'h:mm:ss a' };

/**
 * Returns the locale object used by date-fns lib for the given locale.
 */
export const getDateLocale = (locale: Locale) => {
    switch (locale.code) {
        case 'de':
            return de;
        case 'nl':
            return nl;
        case 'es':
            return es;
        case 'fr':
            return fr;
        case 'it':
            return it;
        case 'ja':
            return ja;
        case 'zh-Hans':
            return zhCN;
        case 'en':
        default:
            return enUS;
    }
};
